module.exports = __webpack_public_path__ + "media/images/pic/saska/hero-adults-1efca55ba896a7c5ca9619edade68d12.svg";